import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'app-overflow-tooltip',
    templateUrl: './overflow-tooltip.component.html',
    styleUrls: ['./overflow-tooltip.component.less'],
})
export class OverflowTooltipComponent {
    @Input() text: string | undefined | null;
    @Input() html: string | undefined | null;
    @Input() isLink = false;
    @ViewChild('tooltipText') tooltipText: ElementRef | undefined;
    showTooltip = false;

    timeout: number | null = null;

    initTooltip(): void {
        const scrollWidth = this.tooltipText?.nativeElement.scrollWidth;
        const clientWidth = this.tooltipText?.nativeElement.clientWidth;
        this.showTooltip = clientWidth < scrollWidth;
    }

    mouseEnter(): void {
        this.initTooltip();
    }

    clickLink(): void {
        if (!this.isLink || !this.text) {
            return;
        }
        window.open(this.text, '_blank');
    }
}
